import axiosInstance from "../../lib/axios";

export async function insertMessPlan(payload){
    try {
      return await axiosInstance.post('MstMessPlan/InsertMstMessPlan',payload);  
    } catch (error) {
      return error;  
    }
}
export async function updateMessPlan(payload){
    try {
        return await axiosInstance.post('MstMessPlan/UpdateMstMessPlan',payload); 
    } catch (error) {
        return error;
    }
}
export async function retriveMessPlan(payload){
    try {
        return await axiosInstance.post('MstMessPlan/RetriveMstMessPlan',payload); 
    } catch (error) {
        return error;
    }
}
